//
//
//
//
//
//

export default {
  name: 'InputWrapper',
  props: {
    error: {
      type: String,
      default: '',
    },
    checkBox: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldType() {
      return this.checkBox ? 'checkbox-wrapper' : 'form-field'
    },
  },
}
